import { useMemo } from 'react';
import { useSession } from '@sdk/session/SessionContext';

import { getDateFormatter } from '@web/announcements/utils/getDateFormatter';

export const useAnnouncementsUtils = () => {
  const {
    currentUser: {
      id: currentUserId,
      isAdmin,
      isManager,
      settings: { usTimeFormat },
    },
  } = useSession();

  return useMemo(
    () => ({
      checkIfCanManage: (authorId: ID) => isAdmin || authorId === currentUserId,
      dateFormatter: getDateFormatter(usTimeFormat),
      isReceiver: !(isAdmin || isManager),
      isSender: isAdmin || isManager,
    }),
    [currentUserId, isAdmin, isManager, usTimeFormat]
  );
};
